import React from 'react'
import { ActivityIndicator, StyleSheet, View } from 'react-native'
import { DS } from '@/design-system'

function Loading({ color = DS.palette['Brand/Maroon'] }: { color?: string }) {
  return (
    <View style={styles.container}>
      <ActivityIndicator size="large" color={color} />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center'
  }
})

export default Loading
